const FieldTypes = {
  TEXT: 'text',
  CHECKBOX: 'checkbox',
  ACCOUNT_NUMBER: 'account_number',
  SIGNATURE: 'signature',
  DATE: 'date',
  PHONE: 'phone',
};
const fieldIconTypes = (fieldType) => {
  switch (fieldType) {
    case FieldTypes.TEXT:
      return { type: FieldTypes.TEXT, icon: ['far', 'text-size'] };
    case FieldTypes.CHECKBOX:
      return { type: FieldTypes.CHECKBOX, icon: ['fas', 'square-check'] };
    case FieldTypes.SIGNATURE:
      return { type: FieldTypes.SIGNATURE, icon: ['fas', 'signature'] };
    case FieldTypes.ACCOUNT_NUMBER:
      return { type: FieldTypes.ACCOUNT_NUMBER, icon: ['fas', 'hashtag'] };
    case FieldTypes.DATE:
      return { type: FieldTypes.DATE, icon: ['fas', 'calendar'] };
    case FieldTypes.PHONE:
      return { type: FieldTypes.PHONE, icon: ['fas', 'phone'] };
    default:
      return { type: FieldTypes.TEXT, icon: ['far', 'text-size'] };
  }
};

// Label for a field in a picker. Repeating table cells share one label across every
// row ("Date (MM/DD)" x4), so the field_key is appended to tell them apart — it is
// the only identifier the backend keys answers by.
const fieldOptionLabel = (field) => {
  if (!field) {
    return '';
  }
  const name = field.label || field.field_name || field.field_key;
  return name === field.field_key ? name : `${name} (${field.field_key})`;
};

const STATUS = {
  in_progress: 'in progress',
  extracting: 'extracting',
  matching: 'matching',
  completed: 'completed',
  failed: 'failed',
};

export { FieldTypes, fieldIconTypes, fieldOptionLabel, STATUS };
